import * as React from "react";
//var __html=require('./FB-HelpContent.html');
import Breadcrumbs from './../../common/components/FDIC/Breadcrumbs';
//var template = {__html: __html};

class HelpContent extends React.Component {
  componentDidMount() {
    document.title = "Failed Banks Help";
  }
    public render() {
      return (
        
        <React.Fragment>
        
        <Breadcrumbs pageTitle="Bank Failures Data" />
        
        <div id="content">
          <div className="ds-u-padding-bottom--3">
          
            <h1 className="ds-u-margin-bottom--3">Failed Banks Help</h1>
            
<p><a href="#INTRODUCTION">INTRODUCTION</a></p>
<p><a href="#DATA SOURCES">DATA SOURCES</a></p>
<p><a href="#METHODOLOGY">METHODOLOGY</a></p>
<p><a href="#COMPARABILITY OF DATA">COMPARABILITY OF DATA</a></p>
<p><a href="#LEVEL OF CONSOLIDATION">LEVEL OF CONSOLIDATION</a></p>
<p><a href="#VALIDATION">VALIDATION</a></p>
<p><a href="#EXCLUSIONS">EXCLUSIONS</a></p>
<p><a href="#DEFINITIONS">DEFINITIONS</a></p>
<p><a href="#FDIC-Insured Institutions">FDIC-Insured Institutions</a></p>
<p><a href="#Charter Class">Charter Class</a></p>
<p><a href="#Charter Type">Charter Type</a></p>
<p><a href="#All Charters">All Charters</a></p>
<p><a href="#Insured Commercial Banks">Insured Commercial Banks</a></p>
<p><a href="#Insured Savings Institutions">Insured Savings Institutions</a></p>
<p><a href="#Insured Branches of Foreign Banks">Insured Branches of Foreign Banks</a></p>
<p><a href="#Effective Date">Effective Date</a></p>
<p><a href="#FDIC-Insured Commercial Banks">FDIC-Insured Commercial Banks</a></p>
<p><a href="#National banks">National banks</a></p>
<p><a href="#FDIC-Insured Savings Institutions">FDIC-Insured Savings Institutions</a></p>
<p><a href="#Cert">Cert</a></p>
<p><a href="#Failure/Assistance">Failure/Assistance</a></p>
<p><a href="#Estimated Loss">Estimated Loss</a></p>
<p><a href="#Insurance Fund">Insurance Fund</a></p>
<p><a href="#FIN">FIN</a></p>
<p><a href="#State">State</a></p>
<p><a href="#Location">Location</a></p>
<p><a href="#Institution Name">Institution Name</a></p>
<p><a href="#Total Assets">Total Assets</a></p>
<p><a href="#Total Deposits">Total Deposits</a></p>
<p><a href="#Transaction Types">Transaction Types</a></p>
<p><a href="#COMMENTS, SUGGESTIONS AND REQUESTS">COMMENTS, SUGGESTIONS AND REQUESTS</a></p>
<p><a href="#DATA AVAILABILITY">DATA AVAILABILITY</a></p>
<p><a href="#FAILURES/ASSISTS TRANSACTIONS REPORT TYPES">FAILURES/ASSISTS TRANSACTIONS REPORT TYPES</a></p>
<p><a href="#Institution Name">Institution Name</a></p>
<p><a href="#Cert">Cert</a></p>
<p><a href="#FIN">FIN</a></p>
<p><a href="#Location">Location</a></p>
<p><a href="#Effective Date">Effective Date</a></p>
<p><a href="#Insurance Fund">Insurance Fund</a></p>
<p><a href="#Transaction Types">Transaction Types</a></p>
<p><a href="#Charter Class">Charter Class</a></p>
<p><a href="#Total Deposits">Total Deposits</a></p>
<p><a href="#Total Assets">Total Assets</a></p>
<p><a href="#Estimated Loss">Estimated Loss</a></p>

<h2 id="INTRODUCTION">INTRODUCTION</h2>

<p>The Historical Statistics on Banking (HSOB) is intended to
be a reference and source document for those interested in banking history and
in performing analyses on major trends in banking. It contains both structure
and financial data on insured commercial banks and savings institutions from
the Federal Deposit Insurance Corporation's inception in 1934 to the present as
well as bank failures and assistance transactions. Its primary goal is to
provide comprehensive industry data about FDIC-insured depository institutions.
</p>



<p>In addition to the HSOB, the FDIC offers other products that
may provide more detail and analysis for current and historical data. These
products include data for individual institutions, summary level data and peer
group analysis. These products can be found under the Bank Data and Statistics
or the Research and Analysis pages on the FDIC's web site, www.fdic.gov.</p>



<p>FDIC.gov → INDUSTRY ANALYSIS → Bank Data and Statistics</p>



<p>Call Reports and Thrift Financial Reports -
http://www5.fdic.gov/Call_TFR_Rpts/index.asp</p>



<p>Central Data Repository - https://cdr.ffiec.gov/public/</p>



<p>Call Reports and Thrift Financial Reports from 2001 to the
present for individual banks and savings associations are available for viewing
and downloading.</p>



<p>Institution Directory - http://www5.fdic.gov/idasp/advSearchLanding.asp </p>



<p>The FDIC Institution Directory (ID) provides the latest
comprehensive financial and demographic data for every FDIC-insured
institution, including the most recent quarterly financial statements, with
performance and condition ratios.</p>



<p>Statistics on Depository Institutions -
http://www5.fdic.gov/sdi/main.asp </p>



<p>The FDIC Statistics on Depository Institutions (SDI) is an
advanced feature of the Institution Directory (ID) that allows you to obtain
more detailed financial reports. It also provides you with the ability to
create reports containing customized peer groups of FDIC-insured institutions
as well as summarize that data at the bank holding company level.</p>



<p>FDIC.gov → INDUSTRY ANALYSIS → Research and Analysis</p>



<p>FDIC Quarterly Banking Profile - http://www5.fdic.gov/qbp/index.asp</p>

<p>The FDIC Quarterly Banking Profile (QBP) provides the most
timely comprehensive summary of financial results for all FDIC-insured
institutions on a quarterly basis. This report card on industry status and
performance includes written analyses, graphs and statistical tables.</p>



<p> Statistics on Banking - http://www5.fdic.gov/SDI/SOB/</p>



<p>The Statistics on Banking is a quarterly publication that
provides detailed aggregate financial information as well as key structural
data (number of institutions and branches) for all FDIC- insured institutions.</p>



<p>For additional information regarding these publications,
please refer to the individual web sites or the Bank Data Guide,
http://www.fdic.gov/bank/statistical/guide/index.html.</p>





<h2 id="DATA SOURCES">DATA SOURCES</h2>



<p>The structure and financial data sources used in the
preparation of the publication are:</p>

<p>Annual Reports of the Federal Deposit Insurance Corporation, 1934
- current</p>

<p>Assets and Liabilities, Commercial and Mutual Savings Banks, 1934
- 1983</p>

<p>Bank Operating Statistics, 1968 - 1983</p>

<p>FDIC's Research Information System (RIS), 1984 - current</p>



<p>The primary sources of financial data for the publications
listed above are the Reports of Income and Condition submitted by FDIC-insured
institutions to the Federal commercial bank regulators and the Thrift Financial
Reports submitted by the FDIC-insured savings institutions that were regulated
by the Office of Thrift Supervision (1984-2011). Structure data are based on
information contained in the FDIC financial institution structure data base
(SIMS).</p>



<h2 id="METHODOLOGY">METHODOLOGY</h2>

<p>In order to provide the most recent and accurate data, all
financial data at both the national and state levels from 1984 to the present have
been obtained from the FDIC's Research Information System (RIS). The data in
the data base reflects revisions and amendments made subsequent to publication
in the hard copy sources. All other data has been obtained from the other four
sources listed above. When using published data, both structure and financial
values were obtained from the latest edition reflecting the data for a
particular year. For example, the 1965 Annual Report was the source for much of
the 1957 data that appear in the publication. Since not all data, particularly
at the state level, were revised and republished in later editions of the
sources, multiple sources for the same year had to be used. The effect of using
two sources occasionally results in differences in aggregate values for the
data. These differences are not considered significant for the intended use and
purpose of the publication</p>



<h2 id="COMPARABILITY OF DATA">COMPARABILITY OF DATA</h2>

<p>Reporting requirements and instructions have changed
considerably over the period covered by this publication. Where possible,
adjustments have been made to account for these differences to make the values
adhere as closely as possible to current requirements and instructions. The
notes accompanying the tables are an integral part of the publication and
provide information on adjustments made to source data and on reporting
differences over time.</p>



<h2 id="LEVEL OF CONSOLIDATION">LEVEL OF CONSOLIDATION</h2>

<p>All data from 1934 to 1973 represent a consolidation of all
domestic operations of the institutions and, where available, operations in
what is designated &quot;Other Areas&quot; in source publications. &quot;Other
areas&quot; are represented by Guam, Puerto Rico, Virgin Islands, and all other
U.S. Territories and possessions. With some exceptions, primarily at the state
level, all financial data from 1974 to the present represent the consolidation
of domestic and foreign operations, including operations in &quot;other
areas&quot;.</p>



<h2 id="VALIDATION">VALIDATION</h2>

<p>Every attempt has been made to assure the accuracy and
integrity of the data contained in the publication. Any inconsistency brought
to our attention will be investigated and corrected or explained in future
editions.</p>



<h2 id="EXCLUSIONS">EXCLUSIONS</h2>

<p>Data on depository institutions not insured by the FDIC are
not included in this publication. Institutions in the following categories are
excluded, although such institutions may perform many of the same functions as
FDIC-insured depository institutions:</p>

<p>State-chartered and private banks not insured by the FDIC</p>

<p>FDIC-Insured domestic branches of foreign banks (IBA offices)</p>

<p>Nondeposit trust companies</p>



<p>Other institutions not insured by the FDIC, including credit
unions, building and loan associations, personal loan companies, industrial
banks, loan and investment companies, and similar institutions, chartered under
laws applicable to such institutions or under general incorporation laws
regardless of whether such institutions are called 'banks'</p>



<p>Institutions chartered under banking or trust company laws,
but operating as investment or title insurance companies and not engaged in
deposit taking Federal Reserve Banks and other banks, such as the Federal Home
Loan Banks, which operate as rediscount banks and do not accept deposits except
from financial institutions</p>



<p>Branches of FDIC-insured OTS-regulated institutions</p>



<h2 id="DEFINITIONS">DEFINITIONS</h2>

<p>Please note that the terms listed below are a partial list
of definitions that are available. Other definitions are available in the Help
Index, Institution Directory (ID) and Statistics on Banking (SOB) systems.</p>



<h3 id="FDIC-Insured Institutions">FDIC-Insured Institutions</h3>

<p>The category of FDIC-insured commercial banks includes all
commercial banks insured by the Federal Deposit Insurance Corporation (FDIC).
It also includes all commercial banks insured by the FDIC that are regulated by
and submit financial data to one of the three Federal commercial bank
regulators (Board of Governors of the Federal Reserve System, Federal Deposit
Insurance Corporation or Office of the Comptroller of the Currency). The
category of FDIC-insured savings institutions includes all institutions insured
by the FDIC that operated under state or federal banking codes applicable to
thrift institutions. Data on savings institutions that have been placed in
Resolution Trust Corporation conservatorship (1989 through 1995) are not
aggregated with other savings institutions, since they do not operate as
privately-held entities, and their resolution costs do not accrue to the FDIC.
These RTC conservatorship institutions are listed separately as memoranda items
where applicable.</p>



<h3 id="Charter Class">Charter Class</h3>

<p>The FDIC assigns classification codes indicating an
institution's charter type (commercial bank, savings bank, or savings
association), its chartering agent (state or federal government), its Federal
Reserve membership status (member or nonmember), and its primary federal
regulator (state-chartered institutions are subject to both federal and state
supervision). These codes are:</p>



<p>N National chartered commercial bank supervised by the Office of the Comptroller of the</p>

<p>SM State charter Fed member commercial bank supervised by the Federal Reserve</p>

<p>NM State charter Fed nonmember commercial bank supervised by the
FDIC</p>

<p>SA State or federal charter savings association supervised by the
Office of Thrift Supervision or Office of the Comptroller of the Currency</p>

<p>SB State charter savings bank supervised by the FDIC</p>



<h3 id="Charter Type">Charter Type</h3>

<p>A charter is the legal authorization to conduct business and
is granted to a financial institution by federal or state government. Charter
types include:</p>



<h3 id="All Charters">All Charters</h3>

<p>Commercial banks, savings institutions and U.S. branches of
foreign banks insured by the FDIC.</p>



<h3 id="Insured Commercial Banks">Insured Commercial Banks</h3>

<p>Commercial banks insured by the FDIC. These institutions are
regulated by one of the three Federal commercial bank regulators (FDIC, Federal
Reserve Board or Office of the Comptroller of the Currency). The institutions
submit financial reports to the Federal Reserve (state member banks), the FDIC
(state nonmember banks), or the Office of the Comptroller of the Currency
(national banks).</p>



<h3 id="Insured Savings Institutions">Insured Savings Institutions</h3>

<p>Savings institutions insured by FDIC that operate under
state or federal banking codes applicable to thrift institutions.</p>



<h3 id="Insured Branches of Foreign Banks">Insured Branches of Foreign Banks</h3>

<p>Branches of foreign banks (banks chartered and headquartered
outside the U.S.) that are insured by the FDIC. These institutions are
regulated by one of the three Federal commercial bank regulators and submit
financial data to the Federal Reserve.</p>



<h3 id="Effective Date">Effective Date</h3>

<p>The date that the failed / assisted institution ceased to
exist as a privately held going concern. For institutions that entered into
government ownership, such as FDIC Bridge Banks and RTC conservatorships, this
is the date that they entered into such ownership. </p>



<h3 id="FDIC-Insured Commercial Banks">FDIC-Insured Commercial Banks</h3>

<p>Includes all commercial banks insured by the FDIC. These
institutions are regulated by and submit financial data to one of three federal
commercial bank regulators (the Federal Reserve Board, the FDIC, or the Office
of the Comptroller of the Currency). FDIC-insured commercial banks include the
following categories of depository institutions insured by the FDIC:</p>



<h3 id="National banks">National banks</h3>

<p>State-chartered banks and trust companies, except savings
banks</p>

<p>Commercial banks, either nationally or state-chartered,
insured by the FDIC</p>

<p>Other financial institutions which operate under general
banking codes, or are specifically authorized by law to accept deposits and in
practice do so or the obligations of which are regarded as deposits for deposit
insurance</p>



<h3 id="FDIC-Insured Savings Institutions">FDIC-Insured Savings Institutions</h3>

<p>Includes all institutions insured by either the FDIC
operating under state or federal banking codes applicable to savings
institutions. Data on savings institutions that have been placed in RTC
conservatorship are not aggregated with those that were not, since the former
do not operate as privately-held entities, and their resolution costs do not
accrue to the FDIC. These RTC conservatorships are listed separately as
memoranda, where applicable.</p>



<h3 id="Cert">Cert</h3>

<p>The certificate number assigned by the FDIC used to identify
institutions and for the issuance of insurance certificates. By clicking on
this number, you will link to the Institution Directory (ID) system which will
provide the last demographic and financial data filed by the selected
institution.</p>



<h3 id="Failure/Assistance">Failure/Assistance</h3>

<p>The given institution has failure stature or it can be
assistance has been provided by FDIC in merging with other institution.</p>



<h3 id="Estimated Loss">Estimated Loss</h3>

<p>The estimated loss is the difference between the amount
disbursed from the Deposit Insurance Fund (DIF) to cover obligations to insured
depositors and the amount estimated to be ultimately recovered from the liquidation
of the receivership estate. Estimated losses reflect unpaid principal amounts
deemed unrecoverable and do not reflect interest that may be due on the DIF's
administrative or subrogated claims should its principal be repaid in full.</p>



<p>Notes:</p>

<p>Comprehensive data on estimated losses are not available for
FDIC-insured failures prior to 1986, or for FSLIC-insured failures from
1934-88. Estimated loss is presented as &quot;N/A&quot; in years for which
comprehensive information is not available.</p>



<p>Estimated Loss data was previously referred to as 'Estimated
Cost' in past releases of the Historical Statistic on Banking. For RTC
receiverships, the 'Estimated Cost' included an allocation of FDIC corporate
revenue and expense items such as interest expense on Federal Financing Bank
debt, interest expense on escrowed funds and interest revenue on advances to
receiverships. Other FDIC receiverships did not include such an allocation. To
maintain consistency with FDIC receiverships, the RTC allocation is no longer
reflected in the estimated loss amounts for failed / assisted institutions that
were resolved through RTC receiverships.</p>



<p>Beginning with the release of 2007 information, the
'Estimated Loss' in the Historical Statistics on Banking is presented and
defined consistently with the aggregate Estimated Receivership Loss for FRF-RTC
institutions and Estimated Losses for FDIC receiverships that are reported in
the FDIC's Annual Report. The estimated loss is obtained from the FDIC's Failed
Bank Cost Analysis (FBCA) report and the RTC Loss report. The FBCA provides
data for receiverships back to 1986. The RTC Loss Report provides similar data
back to 1989.</p>

<p>Questions regarding Estimated Loss should be sent to
DOFBusinessCenter@fdic.gov.</p>



<p>Also, for more detail regarding resolution transactions and
the FDIC's receivership activities, see Managing the Crisis: The FDIC and RTC
Experience, a historical study prepared by the FDIC's Division of Resolutions
and Receiverships. Copies are available from the FDIC's Public Information
Center.</p>



<h2 id="Insurance Fund">Insurance Fund</h2>

<p>Before 1989, there were two federal deposit insurance funds,
one administered by the FDIC, which insured deposits in commercial banks and
state-chartered savings banks, and another administered by the Federal Savings
and Loan Insurance Corporation (FSLIC), which insured deposits in state- and
federally-chartered savings associations. In 1989, the Financial Institutions
Reform, Recovery and Enforcement Act (FIRREA) specified that thereafter the
FDIC would be the federal deposit insurer of all banks and savings associations
and would administer both the FDIC fund, which was renamed the Bank Insurance
Fund (BIF) and the replacement for the insolvent FSLIC fund, which was called
the Savings Association Insurance Fund (SAIF). Although it was created in 1989,
the SAIF was not responsible for savings association failures until 1996. From
1989 through 1995, savings association failures were the responsibility of the
Resolution Trust Corporation (RTC). In February 2006, The Federal Deposit
Insurance Reform Act of 2005 provided for the merger of the BIF and the SAIF
into a single Deposit Insurance Fund (DIF). Necessary technical and conforming
changes to the law were made under The Federal Deposit Insurance Reform
Conforming Amendments Act of 2005. The merger of the funds was effective on
March 31, 2006. For additional information about deposit insurance fund and
legislation, go to http://www.fdic.gov/deposit/insurance/index.html.</p>



<h2 id="FIN">FIN</h2>

<p>Financial Institution Number is a unique number assigned to
the institution as an Assistance Agreement, Conservatorship, Bridge Bank or
Receivership.</p>



<h2 id="State">State</h2>

<p>The state in which the headquarters of the institution are
physically located. The FDIC Act defines state as any State of the United
States, the District of Columbia, and any territory of the United States,
Puerto Rico, Guam, American Samoa, the Trust Territory of the Pacific Islands,
the Virgin Island, and the Northern Mariana Islands.</p>

<p>You can select one of the three summary levels or individual
states, but not both. For the Bank Failures and Assistance Transaction report
you can select multiple states by holding down the Control Key and selecting
specific states.</p>



<h2 id="Location">Location</h2>

<p>The city and state (or territory) of the headquarters of the
institution.</p>



<h2 id="Institution Name">Institution Name</h2>

<p>This is the legal name of the institution. When available,
the Institution's name links to useful information for the customers and
vendors of these institutions. This information includes press releases,
information about the acquiring institution, (if applicable), how your accounts
and loans are affected, and how vendors can file claims against the
receivership. </p>



<h2 id="Total Assets">Total Assets</h2>

<p>The Total assets owned by the institution including cash,
loans, securities, bank premises and other assets as of the last Call Report or
Thrift Financial Report filed by the institution prior to the effective date.
Note this does not necessarily reflect total assets on the last report filed
because in some cases reports were filed after the effective date. This total
does not include off-balance-sheet accounts.</p>



<h2 id="Total Deposits">Total Deposits</h2>

<p>Total including demand deposits, money market deposits,
other savings deposits, time deposits and deposits in foreign offices as of the
last Call Report or Thrift Financial Report filed by the institution prior to
the effective date. Note this does not necessarily reflect total deposits on
the last report filed because in some cases reports were filed after the
effective date.</p>



<h2 id="Transaction Types">Transaction Types</h2>

<p>Institutions have been resolved through several different
types of transactions. The transaction types outlined below can be grouped into
three general categories, based upon the method employed to protect insured
depositors and how each transaction affects a failed / assisted institution's
charter. In most assistance transactions, insured and uninsured depositors are
protected, the failed / assisted institution remains open and its charter
survives the resolution process. In purchase and assumption transactions, the
failed / assisted institution's insured deposits are transferred to a successor
institution, and its charter is closed. In most of these transactions,
additional liabilities and assets are also transferred to the successor
institution. In payoff transactions, the deposit insurer - the FDIC or the
former Federal Savings and Loan Insurance Corporation - pays insured
depositors, the failed / assisted institution's charter is closed, and there is
no successor institution. For a more complete description of resolution
transactions and the FDIC's receivership activities, see Managing the Crisis:
The FDIC and RTC Experience, a study prepared by the FDIC's Division of
Resolutions and Receiverships. Copies are available from the FDIC's Public
Information Center.</p>



<p><b>Category 1 - Institution's charter survives</b></p>



<p> A/A (Assistance Transactions). These include:</p>



<p>transactions</p>
<p>where assistance was provided to the acquirer, who purchased the entire
institution. For a few FSLIC transactions, the acquirer purchased the entire
bridge bank - type entity, but certain other assets were moved into a
liquidating receivership prior to the sale, and</p>



<p>open bank</p><p>
assistance transactions, including those where assistance was provided under a
systemic risk determination (in such cases any costs that exceed the amounts
estimated under the least cost resolution requirement would be recovered
through a special assessment on all FDIC-insured institutions).</p>



<p>REP - Re-privatization, management takeover with or without
assistance at takeover, followed by a sale with or without additional
assistance.</p>



<p><b>Category 2 - Institution's charter is terminated</b>,
insured deposits plus some assets and other liabilities are transferred to a
successor charter</p>



<p>P&amp;A - Purchase and Assumption, where some or all of the
deposits, certain other liabilities and a portion of the assets (sometimes all
of the assets) were sold to an acquirer. It was not determined if all of the
deposits (PA) or only the insured deposits (PI) were assumed.</p>



<p> PA - Purchase and Assumption, where the insured and
uninsured deposits, certain other liabilities and a portion of the assets were
sold to an acquirer.</p>



<p> PI - Purchase and Assumption of the insured deposits only,
where the traditional P&amp;A was modified so that only the insured deposits
were assumed by the acquiring institution.</p>



<p>IDT - Insured Deposit Transfer, where the acquiring
institution served as a paying agent for the insurer, established accounts on
their books for depositors, and often acquired some assets as well. Includes
ABT (asset-backed transfer, a FSLIC transaction that is very similar to an
IDT).</p>



<p>MGR - An institution where FSLIC took over management and
generally provided financial assistance. FSLIC closed down before the
institution was sold.</p>



<p><b>Category 3</b></p>

<p>PO - Payout, where the insurer paid the depositors directly
and placed the assets in a liquidating receivership.</p>

<p>Note: Includes transactions where the FDIC established a
Deposit Insurance National Bank to facilitate the payout process.</p>



<h2 id="COMMENTS, SUGGESTIONS AND REQUESTS">COMMENTS, SUGGESTIONS AND REQUESTS</h2>



<p>Comments and content suggestions for the Historical Statistics
on Banking should be sent to:</p>

<p><a href="http://www5.fdic.gov/idasp/DIRSInfoRequest.asp">http://www5.fdic.gov/idasp/DIRSInfoRequest.asp</a>.</p>



<h2 id="DATA AVAILABILITY">DATA AVAILABILITY</h2>



<p>Historical Statistics on Banking (HSOB) provides annual
statistical information on the banking industry beginning in 1934. These data
can be used to identify and analyze long-term trends and to develop benchmarks
to evaluate the current condition of the banking and thrift industries.</p>



<p>FDIC provides financial and structural data about individual
institutions in the Institution Directory (ID).</p>



<p>Failures and Assistance Transactions (1934-2017) are updated
as necessary. The last update was on October 2017.</p>

<p>Estimated Loss (year end data, December 2-17) is updated
annually. The last update was on February 2018. The next update is scheduled
for February 2019.</p>



<h2 id="FAILURES/ASSISTS TRANSACTIONS REPORT TYPES">FAILURES/ASSISTS TRANSACTIONS REPORT TYPES</h2>

<p>Report Types</p>

<p>Detail - lists each failure or assistance transaction by the selected sort order for the time period(s) and state(s)
selected. Data includes the institution name, certificate number, FIN number,
location (city, state), Effective Date (date of failure), insurance fund,
failure transaction type, charter class, total deposits and total assets last
reported prior to failure and the estimated cost of resolution. Sort options
are available for these variables. Optional selection criteria include Funds,
Charter Types and Transaction Types.</p>



<p>Summary by State - this is a summary of by state of the &quot;Detail&quot; report for the specified time
period. Statistics include the number of failures by state, total deposits and
total assets last reported prior to failure and the estimated cost of
resolution. Optional selection criteria include Funds, Charter Types and
Transaction Types.</p>



<p>Summary by Year - lists the number by closed or assisted institutions for the selected state (or all states
totals) by year. Statistics include a breakdown of Total Institutions, Fund,
Charter Class and Transaction Types. Sort options are available for these
variables. No optional selection criteria are available for the Summary Report.
</p>



<h2 id="Institution Name">Institution Name</h2>

<p>The legal name of the failed / assisted institution. When
available, the Institution's name links to useful information for the customers
and vendors of these institutions. This information includes press releases,
information about the acquiring institution(if applicable), how your accounts
and loans are affected, and how vendors can file claims against the
receivership.</p>



<h2 id="Cert">Cert</h2>

<p>The certificate number assigned by the FDIC used to identify
institutions and for the issuance of insurance certificates.</p>



<h2 id="FIN">FIN</h2>

<p>Financial Institution Number is a unique number assigned to
the institution as an Assistance Transaction Agreement, Conservatorship, Bridge
Bank or Receivership.</p>



<h2 id="Location">Location</h2>

<p>The city and state (or territory) of the headquarters of the
failed / assisted institution.</p>



<h2 id="Effective Date">Effective Date</h2>

<p>The date that the failed / assisted institution ceased to
exist as a privately held going concern. For institutions that entered into
government ownership, such as FDIC Bridge Banks and RTC Conservatorships, this
is the date that they entered into such ownership.</p>



<h2 id="Insurance Fund">Insurance Fund</h2>

<p>Before 1989, there were two federal deposit insurance funds,
one administered by the FDIC, which insured deposits in commercial banks and
state-chartered savings banks, and another administered by the Federal Savings
and Loan Insurance Corporation (FSLIC), which insured deposits in state- and
federally-chartered savings associations. In 1989, the Financial Institutions
Reform, Recovery and Enforcement Act (FIRREA) specified that thereafter the
FDIC would be the federal deposit insurer of all banks and savings associations
and would administer both the FDIC fund, which was renamed the Bank Insurance
Fund (BIF) and the replacement for the insolvent FSLIC fund, which was called
the Savings Association Insurance Fund (SAIF). Although it was created in 1989,
the SAIF was not responsible for savings association failures until 1996. From
1989 through 1995, savings association failures were the responsibility of the
Resolution Trust Corporation (RTC). In February 2006, The Federal Deposit
Insurance Reform Act of 2005 provided for the merger of the BIF and the SAIF
into a single Deposit Insurance Fund (DIF). Necessary technical and conforming
changes to the law were made under The Federal Deposit Insurance Reform
Conforming Amendments Act of 2005. The merger of the funds was effective on
March 31, 2006.</p>



<p>For additional information about deposit insurance fund and
legislation, go to http://www.fdic.gov/deposit/insurance/index.html.</p>



<h2 id="Transaction Types">Transaction Types</h2>

<p>Institutions have been resolved through several different
types of transactions. The transaction types outlined below can be grouped into
three general categories, based upon the method employed to protect insured
depositors and how each transaction affects a failed / assisted institution's
charter. In most assistance transactions, insured and uninsured depositors are
protected, the failed / assisted institution remains open and its charter
survives the resolution process. In purchase and assumption transactions, the
failed / assisted institution's insured deposits are transferred to a successor
institution, and its charter is closed. In most of these transactions,
additional liabilities and assets are also transferred to the successor
institution. In payoff transactions, the deposit insurer - the FDIC or the
former Federal Savings and Loan Insurance Corporation - pays insured
depositors, the failed / assisted institution's charter is closed, and there is
no successor institution. For a more complete description of resolution
transactions and the FDIC's receivership activities, see Managing the Crisis:
The FDIC and RTC Experience, an historical study prepared by the FDIC's
Division of Resolutions and Receiverships. Copies are available from the FDIC's
Public Information Center.</p>



<p><b>Category 1 - Institution's charter survives</b></p>



<p>A/A - Assistance Transactions. These include:</p>

<p>Transactions where assistance was provided to the acquirer, who purchased the entire
institution. For a few FSLIC transactions, the acquirer purchased the entire
bridge bank - type entity, but certain other assets were moved into a
liquidating receivership prior to the sale.</p>

<p>Open bank assistance transactions, including those where assistance was provided under a
systemic risk determination (in such cases any costs that exceed the amounts
estimated under the least cost resolution requirement would be recovered
through a special assessment on all FDIC-insured institutions).</p>



<p>REP - Reprivatization, management takeover with or without
assistance at takeover, followed by a sale with or without additional
assistance.</p>





<p><b>Category 2 - Institution's charter is terminated</b>,
insured deposits plus some assets and other liabilities are transferred to a
successor charter</p>



<p>P&amp;A - Purchase and Assumption, where some or all of the
deposits, certain other liabilities and a portion of the assets (sometimes all
of the assets) were sold to an acquirer. It was not determined if all of the
deposits (PA) or only the insured deposits (PI) were assumed.</p>



<p> PA - Purchase and Assumption, where the insured and
uninsured deposits, certain other liabilities and a portion of the assets were
sold to an acquirer.</p>



<p> PI - Purchase and Assumption of the insured deposits only,
where the traditional P&amp;A was modified so that only the insured deposits
were assumed by the acquiring institution.</p>



<p>IDT - Insured Deposit Transfer, where the acquiring
institution served as a paying agent for the insurer, established accounts on
their books for depositors, and often acquired some assets as well. Includes
ABT (asset-backed transfer, a FSLIC transaction that is very similar to an
IDT).</p>



<p>MGR - An institution where FSLIC took over management and
generally provided financial assistance. FSLIC closed down before the
institution was sold.</p>



<p><b>Category 3</b></p>



<p>PO - Payout, where the insurer paid the depositors directly
and placed the assets in a liquidating receivership.</p>



<h2 id="">Charter Class</h2>

<p>The FDIC assigns classification codes indicating an
institution's charter type (commercial bank, savings bank, or savings
association), its chartering agent (state or federal government), its Federal
Reserve membership status (member or nonmember), and its primary federal
regulator (state charter institutions are subject to both federal and state
supervision).</p>



<p>N - National charter commercial bank supervised by the
Office of the Comptroller of the Currency</p>

<p>SM - State charter Fed member commercial bank supervised by
the Federal Reserve</p>

<p>NM - State charter Fed nonmember commercial bank supervised
by the FDIC</p>

<p>SA - State or federal charter savings association supervised
by the Office of Thrift Supervision</p>

<p>SB - State charter savings bank supervised by the FDIC</p>



<h2 id="Total Deposits">Total Deposits</h2>

<p>The sum of all deposits including demand deposits, money
market deposits, other savings deposits, time deposits and deposits in foreign
offices as of the last Call Report or Thrift Financial Report filed by the
institution.</p>



<h2 id="Total Assets">Total Assets</h2>

<p>The sum of all assets owned by the institution including
cash, loans, securities, bank premises and other assets as of the last Call
Report or Thrift Financial Report filed by the institution. This total does not
include off-balance-sheet accounts.</p>



<h2 id="Estimated Loss">Estimated Loss</h2>

<p>The estimated loss is the difference between the amount
disbursed from the Deposit Insurance Fund (DIF) to cover obligations to insured
depositors and the amount estimated to be ultimately recovered from the
liquidation of the receivership estate. Estimated losses reflect unpaid
principal amounts deemed unrecoverable and do not reflect interest that may be
due on the DIF's administrative or subrogated claims should its principal be
repaid in full.</p>
          
          </div>
          
          
        </div>
        </React.Fragment>

      


      );
    }
  }
  
export default HelpContent;